import React, { useRef } from "react";
import { App } from "spry-react/App/app";
import { buildContext } from "./buildContext";
import { IPortalAppContext, PortalAppContext } from "./appContext";
import { PortalLayout } from "Components/Api/GeneratedDTOs/ViewModels/Shared/PortalLayout";
import { CrossSiteRequestForgeryTokenInfo } from "spry-react/utils/fetchExtensions";

/**
 * Renders <App>, builds the context object, stores the context object in react context,
 * and passes the context object to the renderChildren function.
 */
export function AppWithContext(props: {
  layout: PortalLayout;
  getCsrfInfo: () => CrossSiteRequestForgeryTokenInfo;
  isClientSidePage: boolean;
  renderChildren: (
    appContext: IPortalAppContext,
  ) => React.ReactElement<any> | React.ReactElement<any>[] | React.ReactPortal | string | number | null | false;
}) {
  const contextRef = useRef<IPortalAppContext | null>(null);
  return (
    <PortalAppContext.Provider value={contextRef}>
      <App
        renderChildren={(openDialog, registerBeforeUnload, flashMessage, confirm, startSerialOperation, setWindowLocationHref) => {
          const context = buildContext(
            props.layout,
            {
              openDialog,
              registerBeforeUnload,
              flashMessage,
              confirm,
              startSerialOperation,
              setWindowLocationHref,
            },
            props.getCsrfInfo,
            props.isClientSidePage,
          );
          contextRef.current = context;

          return props.renderChildren(context);
        }}
      />
    </PortalAppContext.Provider>
  );
}
